import RSMCheckingQueries from './RSMCheckingQueries'

const products = {
  products: {
    ...RSMCheckingQueries,
  }
}

export default products